/**
 * @generated SignedSource<<22044b91fc97e3193b17bde12ee96ccd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type VoicePrintsDeleteVoicePrintMutation$variables = {
  voicePrintId: string;
};
export type VoicePrintsDeleteVoicePrintMutation$data = {
  readonly deleteVoicePrint: {
    readonly viewer: {
      readonly voicePrints: ReadonlyArray<{
        readonly " $fragmentSpreads": FragmentRefs<"VoicePrints_voicePrint">;
      }>;
    };
  } | null;
};
export type VoicePrintsDeleteVoicePrintMutation = {
  response: VoicePrintsDeleteVoicePrintMutation$data;
  variables: VoicePrintsDeleteVoicePrintMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "voicePrintId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "voicePrintId",
    "variableName": "voicePrintId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "VoicePrintsDeleteVoicePrintMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeleteVoicePrint",
        "kind": "LinkedField",
        "name": "deleteVoicePrint",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Viewer",
            "kind": "LinkedField",
            "name": "viewer",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "VoicePrint",
                "kind": "LinkedField",
                "name": "voicePrints",
                "plural": true,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "VoicePrints_voicePrint"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "VoicePrintsDeleteVoicePrintMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeleteVoicePrint",
        "kind": "LinkedField",
        "name": "deleteVoicePrint",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Viewer",
            "kind": "LinkedField",
            "name": "viewer",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "VoicePrint",
                "kind": "LinkedField",
                "name": "voicePrints",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "audioFileUrl",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "createdAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MeetingRecording",
                    "kind": "LinkedField",
                    "name": "sourceMeetingRecording",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "title",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "url",
                        "storageKey": null
                      },
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "sourceStart",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "c102ddb26da0166d41ae5b0bda3b78a7",
    "id": null,
    "metadata": {},
    "name": "VoicePrintsDeleteVoicePrintMutation",
    "operationKind": "mutation",
    "text": "mutation VoicePrintsDeleteVoicePrintMutation(\n  $voicePrintId: ID!\n) {\n  deleteVoicePrint(voicePrintId: $voicePrintId) {\n    viewer {\n      voicePrints {\n        ...VoicePrints_voicePrint\n        id\n      }\n      id\n    }\n  }\n}\n\nfragment VoicePrints_voicePrint on VoicePrint {\n  id\n  audioFileUrl\n  createdAt\n  sourceMeetingRecording {\n    title\n    url\n    id\n  }\n  sourceStart\n}\n"
  }
};
})();

(node as any).hash = "15fe2032412ae2765182588f4d18f266";

export default node;
